import uploadHelper from '../../MyAccount/ViewDesigns/helpers/uploadHelper';
import _ from 'lodash';

const { uploadFile, deleteFile, resizePreview, getS3VersionedImage, isVersionedUrl } = uploadHelper;
import {isCrazylisterHostedImage} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
const MAX_IMAGES = 30;

export default class MultiImageUploaderHelper {
  _updateCallback;

  constructor(updateCallback) {
    this._updateCallback = updateCallback;
  }

  dropHandler = (files) => {
    files.slice(0, Math.min(files.length, MAX_IMAGES - _.size(this.images))).forEach((file, index) => {
      // since we just added a new image, array length will be the index
      const newImageIndex = this._nextImageIndex++;
      window.setTimeout(()=>{
        this._uploadImage(file, newImageIndex);
      }, index * 200);
    });
  };

  _uploadImage = (file, index = this._nextImageIndex++) => {
    resizePreview(file, () => {
      const uploadXhr = uploadFile(file, (progress) => {
        this._updateImage(index, {progress: progress});
      });
      uploadXhr.then((data, status, jqXHR) => {
        if (!data.uploaded) {
          this._updateImage(index, {failed: true, inProgress: false});
        } else {
          const amzVersionId = jqXHR.getResponseHeader('x-amz-version-id');
          let versionIdQuery = '';
          if (amzVersionId) {
            versionIdQuery = `?versionId=${amzVersionId}`;
          }
          this._updateImage(index, {
            progress: 1,
            ready: true,
            src: data.currentFolder.url + data.fileName + versionIdQuery,
            storedName: data.fileName,
            inProgress: false
          });
        }
      }).fail(() => {
        this._updateImage(index, {failed: true, inProgress: false});
      });
      this._updateImage(index, {...file, originalFile: file, progress: 0, ready: false, failed: false, inProgress: true, deleted: false});
    });
  };

  _updateImage = (index, update) => {
    let image = this.images[index] || {};
    image = {...image, ...update};
    this.images = {...this.images};
    this.images[index] = image;
    this._updateCallback(index, update);
  };

  removeHandler = (index, deleteUploadedImage = false) => {
    const image = this.images[index];
    if (deleteUploadedImage && image.storedName) {
      deleteFile(image.storedName);
    }
    this.images = _.omit(this.images, index);
    this._updateCallback(index, null);
  };

  addExistingImages(srcs) {
    srcs.forEach(this.addExistingImage);
  }

  addExistingImage = (src) => {
    const resizePreviewAndUpdate = (src) => {
      resizePreview(src, (resizedPreview) => {
        this._updateImage(this._nextImageIndex++, {src: src, preview: resizedPreview, ready: true});
      });
    };
    if (isCrazylisterHostedImage(src) && !isVersionedUrl(src)) {
      getS3VersionedImage(src, (img) => {
        if (img) {
          resizePreviewAndUpdate(img.src);
        } else {
          resizePreviewAndUpdate(src);
        }
      });
    } else {
      resizePreviewAndUpdate(src);
    }
  };

  allValid() {
    return _.every(this.images, {ready: true});
  }

  images = {};
  _nextImageIndex = 0;
}
